import { BaseUseCase } from "../../../../useCases/UseCaseBase";
class DerivativeDetailsUseCase extends BaseUseCase {
    constructor(marginRepo) {
        super();
        this.marginRepo = marginRepo;
    }
    async fetchResult(req) {
        return await this.marginRepo.getDerivativeDetails(req);
    }
}
export default DerivativeDetailsUseCase;
